import { supportedLanguages } from '@common'
import { useTranslations } from 'next-intl'
import Image from 'next/legacy/image'
import Link from 'next/link'

import SupercellIdLogo from '@/assets/images/logos/supercell-id-black.svg'

import { useAppSelector } from '../../utils/useAppSelector'
import { useLocale } from '../locale/useLocale'

import styles from './SCID.module.scss'

export const SCIDContainer: React.FC = () => {
  const t = useTranslations()
  const profile = useAppSelector((state) => state.user.profile)
  const email = profile?.identifier?.value
  const name = profile?.profile?.name
  const locale = useLocale()
  const isRTL = supportedLanguages[locale].rightToLeft

  return (
    <div className={styles.ContentContainer}>
      <div className={styles.TitleRow}>
        <h2>{t('acc_scid_title')}</h2>
        <div className={styles.Logout}>
          <Link data-cy="account-logout" href="/oauth/logout">
            {!isRTL ? `${t('switch_acc')} / ${t('logout')}` : `${t('logout')} / ${t('switch_acc')}`}
          </Link>
        </div>
      </div>
      <div className={styles.Info}>
        <Image quality={100} layout="fixed" height={58} width={64} src={SupercellIdLogo} alt={'supercell-id'} />
        <div className={styles.AccountInfo}>
          <p className={styles.Name}>{name}</p>
          <p className={styles.Email}>{email}</p>
        </div>
      </div>
    </div>
  )
}
